import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { fetchSettingsAsync, selectSettings, updateSettingsAsync } from './settingsSlice';
import { Box, Button, Container, Paper, Stack, TextField, Typography } from '@mui/material';
import { setPageName } from '../../../app/appSlice';

const SettingsView = () => {
  const settingsState = useAppSelector(selectSettings);
  const dispatch = useAppDispatch();
  const [testTime, setTestTime] = useState<number | null>(null);

  useEffect(() => {
    dispatch(setPageName('Settings'));
    dispatch(fetchSettingsAsync());
  }, []);

  useEffect(() => {
    if (settingsState.settings) {
      setTestTime(settingsState.settings.testTime);
    }
  }, [settingsState.settings]);

  const handleSave = () => {
    if (testTime) {
      dispatch(updateSettingsAsync({ testTime }));
    }
  };

  if (!settingsState.settings) return null;

  return (
    <Box marginTop={1}>
      <Container maxWidth="sm">
        <Paper>
          <Stack spacing={2} padding={2}>
            <Typography>Time to complete test</Typography>
            <TextField
              label="time (minutes)"
              type="number"
              value={testTime ?? ''}
              onChange={({ target }) => {
                Number(target.value) ? setTestTime(parseInt(target.value)) : setTestTime(null);
              }}
            />
            <Box display="flex" justifyContent="flex-end">
              <Button variant="contained" color="success" onClick={handleSave}>
                Save
              </Button>
            </Box>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};

export default SettingsView;
